/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FileWarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABl0lEQVR4nN2VvU7DQAzHOwATA6wg5iIBIwyoqLCB0rMdpIudLgiGDrAwMTAxlok+AQ+A+JCouiExw9iBN2AqRYIRkIquTao0/UggYeEkSznr/v75bCfJZP7VQuQ5IL5UJO9A0hpmCvnF1wA4u7GDK5TmqMAQsC6gsy9HAkzmcYNDPyAaElUWCJnWerKj4+dYkJ8EB5IWIq97unKoPyepABTxrdFprScMJHSTvcQA6GR7HNncJAAwhlIFcDb8nqQPoNHvyZ8AIDDGiQEK5cs02bKdRcTiEhCfGl+agKMBsdKaInkqlUrj+Xx+TBFfA8qVeU6tycqWzbbWlgPfV0B3Px0AStXoLKs4DcQNRXJuzDwbXyKAQv4A0FmjUygV47MsPQsgM17pKgk/dnxmNIVtd74NM6WxnWUid8U786mULIRuwDcxgzf8EijiWuBWD4Dy2N0T13oBoLNA/Bpjcg7b2RNvBf2IvFogNxf0mTP9v0yUCyB+GxK8ibgz5WVf7w3m5hB5rec8cX3gRMVZiuQ+Rknvfg2Iu74BOemkGpERqNwAAAAASUVORK5CYII=)
 */
export const FileWarningIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.65 13.63c.1.17.35.1.35-.1V10.5a.5.5 0 0 0-.5-.5H19a5 5 0 0 1-5-5V2.5a.5.5 0 0 0-.5-.5H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h5.49c.27 0 .5-.22.54-.5.06-.32.18-.65.37-.97l3.95-6.9a3.06 3.06 0 0 1 5.3 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.7 7.94c.01.03 0 .06-.04.06H19a3 3 0 0 1-3-3V2.34c0-.03.03-.05.06-.04a3 3 0 0 1 .82.58l4.24 4.24a3 3 0 0 1 .58.82Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="m14.13 21.52 3.96-6.9c.4-.68 1.43-.68 1.82 0l3.96 6.9c.38.67-.12 1.48-.91 1.48h-7.92c-.79 0-1.3-.81-.91-1.48Zm3.93-4.47a.5.5 0 0 1 .5-.55h.89c.3 0 .52.26.5.55l-.22 2.02c-.01.16-.17.26-.33.23a1.93 1.93 0 0 0-.8 0c-.16.03-.32-.07-.33-.23l-.21-2.02ZM19 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
